module.exports = __webpack_public_path__ + "img/2000f.d34646b9.png";